const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      region: process.env.REACT_APP_COGNITO_REGION,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scopes: ["openid", "email", "profile"],
          redirectSignIn: [process.env.REACT_APP_OAUTH_REDIRECT_SIGNIN],
          redirectSignOut: [process.env.REACT_APP_OAUTH_REDIRECT_SIGNOUT],
          responseType: "code",
        },
      },
    },
  },
};

export default awsConfig;
